<div class="btn-group" ngbDropdown placement="bottom-right top-right" container="body" skStopPropagation>
    <button sk-icon-button icon="more_horiz" class="sk-dropdown-custom" [ngClass]="{'btn-outline-secondary': showOutline}" ngbDropdownToggle></button>
    <div ngbDropdownMenu>
        <ng-content></ng-content>
    </div>
</div>